import _toConsumableArray from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import React from 'react';
import _ from 'lodash';
export var getFieldRequirements = function getFieldRequirements(field, userRequirements) {
  if (userRequirements) {
    if (field === 'username') {
      return userRequirements.nameRequirements;
    }

    if (field === 'password') {
      var requirements = userRequirements.passwordRequirements; // password requirements has min/max char that we need to use to generate unicode range

      var acceptableSpecialChars = generateSpecialCharUnicodeRange(requirements.minCharAllowed, requirements.maxCharAllowed);
      return Object.assign({}, requirements, {
        acceptableSpecialChars: acceptableSpecialChars
      });
    }
  }
}; // TODO: Need to move away from dangerouslySetInnerHTML.

export var getSpecialCharsAsHtml = function getSpecialCharsAsHtml(acceptableSpecialChars) {
  // set special chars string as html, to interpret unicode html entities
  if (acceptableSpecialChars) {
    return React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: acceptableSpecialChars.replace(/\\u00/g, '&#x')
      }
    });
  }

  return undefined;
};
export var isUserNameEqualToEmail = function isUserNameEqualToEmail(username, email) {
  return _.isEqual(_.toLower(_.trim(username)), _.toLower(_.trim(email)));
};
export var isUserNameContainedInPassword = function isUserNameContainedInPassword(password, username) {
  if (!password || !username) return false;
  return _.includes(_.toLower(_.trim(password)), _.toLower(_.trim(username)));
};
export var doesPasswordContainForbiddenKeywords = function doesPasswordContainForbiddenKeywords(password) {
  if (!password) return false;
  var passwordAllLowerCase = password.toLowerCase();

  if (passwordAllLowerCase.includes('welcome123') || passwordAllLowerCase.includes('welcome01') || passwordAllLowerCase.includes('password')) {
    return true;
  }

  return false;
};
export var isUserNameValid = function isUserNameValid(requirements, username, email) {
  if (!requirements) {
    return false;
  } // separate from dynamic requirements, don't allow username to be same as login email


  if (isUserNameEqualToEmail(username, email)) {
    return false;
  }

  var _requirements$nameReq = requirements.nameRequirements,
      minLength = _requirements$nameReq.minLength,
      maxLength = _requirements$nameReq.maxLength,
      minDigitCount = _requirements$nameReq.minDigitCount,
      minSpecialCount = _requirements$nameReq.minSpecialCount,
      acceptableSpecialChars = _requirements$nameReq.acceptableSpecialChars;

  if (!isRequiredLengthValid(username, minLength, maxLength)) {
    return false;
  }

  if (!isRequiredDigitsValid(username, minDigitCount)) {
    return false;
  }

  if (!isRequiredSpecialCharsValid(username, minSpecialCount, acceptableSpecialChars)) {
    return false;
  }

  return true;
};
export var isPasswordValid = function isPasswordValid(password, requirements, username) {
  if (!requirements) {
    return false;
  }

  if (username) {
    // separate from dynamic requirements, don't allow password to contain username
    if (isUserNameContainedInPassword(password, username)) {
      return false;
    }
  }

  var _requirements$passwor = requirements.passwordRequirements,
      minLength = _requirements$passwor.minLength,
      maxLength = _requirements$passwor.maxLength,
      minLowerCount = _requirements$passwor.minLowerCount,
      minUpperCount = _requirements$passwor.minUpperCount,
      minDigitCount = _requirements$passwor.minDigitCount,
      minSpecialCount = _requirements$passwor.minSpecialCount,
      minCharAllowed = _requirements$passwor.minCharAllowed,
      maxCharAllowed = _requirements$passwor.maxCharAllowed;
  var acceptableSpecialChars = generateSpecialCharUnicodeRange(minCharAllowed, maxCharAllowed);

  if (!isRequiredLengthValid(password, minLength, maxLength)) {
    return false;
  }

  if (!isRequiredDigitsValid(password, minDigitCount)) {
    return false;
  }

  if (!isRequiredLowercaseValid(password, minLowerCount)) {
    return false;
  }

  if (!isRequiredUppercaseValid(password, minUpperCount)) {
    return false;
  }

  if (!isRequiredSpecialCharsValid(password, minSpecialCount, acceptableSpecialChars)) {
    return false;
  }

  if (doesPasswordContainForbiddenKeywords(password)) {
    return false;
  }

  return true;
};

var getRequirementsRegex = function getRequirementsRegex(minLength, maxLength, acceptableSpecialChars) {
  // Escape hyphen in acceptableSpecialChars to ensure it's treated as a literal character
  var escapedSpecialChars = acceptableSpecialChars ? acceptableSpecialChars.replace(/-/g, '\\-') : '';
  return new RegExp("^[a-z0-9".concat(escapedSpecialChars, "-]{").concat(minLength, ",").concat(maxLength || '', "}$"), 'i');
};

export var isRequiredLengthValid = function isRequiredLengthValid(value, minLength, maxLength) {
  // pass in current value as acceptable special chars, to only validate length
  var re = getRequirementsRegex(minLength, maxLength, _.escapeRegExp(value));
  return re.test(value);
};
export var isRequiredSpecialCharsValid = function isRequiredSpecialCharsValid(value, minSpecialCount, acceptableSpecialChars) {
  var re = getRequirementsRegex(minSpecialCount, 0, acceptableSpecialChars);

  if (acceptableSpecialChars) {
    return re.test(value) && (!minSpecialCount || countNumberOfChars(value, new RegExp("[".concat(acceptableSpecialChars, "]"))) >= minSpecialCount);
  }

  return true;
};
export var isRequiredDigitsValid = function isRequiredDigitsValid(value, minDigitCount) {
  if (minDigitCount) {
    return countNumberOfChars(value, /\d/) >= minDigitCount;
  }

  return true;
};
export var isRequiredLowercaseValid = function isRequiredLowercaseValid(value, minLowerCount) {
  if (minLowerCount) {
    return countNumberOfChars(value, /[a-z]/) >= minLowerCount;
  }

  return true;
};
export var isRequiredUppercaseValid = function isRequiredUppercaseValid(value, minUpperCount) {
  if (minUpperCount) {
    return countNumberOfChars(value, /[A-Z]/) >= minUpperCount;
  }

  return true;
};

var countNumberOfChars = function countNumberOfChars(value, charMatch) {
  return _.sumBy(value, function (c) {
    return charMatch.test(c) ? 1 : 0;
  });
};

var generateSpecialCharUnicodeRange = function generateSpecialCharUnicodeRange(minChar, maxChar) {
  var range = '';

  if (minChar && maxChar) {
    // generate ranges for non-special chars that need to be excluded
    var numbersAndLettersRange = [].concat(_toConsumableArray(generateUnicodeDecimalRange('0', '9')), _toConsumableArray(generateUnicodeDecimalRange('A', 'Z')), _toConsumableArray(generateUnicodeDecimalRange('a', 'z')));
    var charRange = generateUnicodeDecimalRange(minChar, maxChar);

    for (var i = 0; i < charRange.length; i++) {
      if (!_.includes(numbersAndLettersRange, charRange[i])) {
        var hex = charRange[i].toString(16);
        range += "\\u".concat('0000'.substring(0, 4 - hex.length)).concat(hex);
      }
    }
  }

  return range;
};

var generateUnicodeDecimalRange = function generateUnicodeDecimalRange(minChar, maxChar) {
  var range = [];
  var minCodePoint = minChar.codePointAt(0) || 0;
  var maxCodePoint = maxChar.codePointAt(0) || -1;

  for (var i = minCodePoint; i <= maxCodePoint; i++) {
    range.push(i);
  }

  return range;
};